import ReactDOM from "react-dom";
import "react-virtualized/styles.css";
import App from "./App/App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import "typeface-inter";
import "./global.scss";
import "@breedr/utils";

Sentry.init({
  dsn: "https://963f53c3b4e5404f9041e381862f6f9e@o366744.ingest.sentry.io/5838828",
  environment: process.env.REACT_APP_BUILD_ENV,
  enabled: process.env.REACT_APP_BUILD_ENV !== "local" || process.env.REACT_APP_BUILD_ENV !== undefined,
  tracesSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
